<div>
  <div class="pull-right datatable-button">
    <div class="d-inline-block mb-2 mt-2">
      <button class="btn btn-primary btn-sm" (click)="reload()">Go home</button>
    </div>
  </div>
  <div class="iframe-wrapper">
    <iframe [src]="page?.fullUrl | safe"  class="page-preview" name="pagepreview"></iframe>
  </div>
</div>
